import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { XCircle, UserCheck, MapPin, Wallet, FileText, Headphones } from 'lucide-react';

const SafetyPage = () => {
  const riderHighlights = [
    {
      icon: <XCircle size={20} />,
      text: '0% cancellations from our side',
    },
    {
      icon: <UserCheck size={20} />,
      text: 'Verified and trained pilots',
    },
    {
      icon: <MapPin size={20} />,
      text: 'Real-time ride tracking & quick support',
    },
  ];

  const pilotHighlights = [
    {
      icon: <Wallet size={20} />,
      text: 'Fixed earning model, no daily pressure',
    },
    {
      icon: <FileText size={20} />,
      text: 'Clear trip details before every ride',
    },
    {
      icon: <Headphones size={20} />,
      text: 'On-road assistance and company support',
    },
  ];

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      
      {/* Hero Section - Equal sized boxes with reduced gap */}
      <section className="pt-32 pb-6 bg-black">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row lg:items-stretch gap-4">
            {/* Left - NURA Safety Standard Box */}
            <div className="bg-[#bceb39] rounded-2xl px-6 py-5 flex-1 flex flex-col justify-center" style={{ minHeight: '160px' }}>
              <h1 className="text-2xl md:text-3xl font-bold text-black mb-2 whitespace-nowrap">NURA Safety Standard</h1>
              <p className="text-base text-black/80">
                Safety that's built into every ride – for riders and pilots alike.
              </p>
            </div>
            
            {/* Right - NURA Safety Standard Badge */}
            <div className="bg-gradient-to-br from-gray-900 to-gray-950 rounded-2xl px-6 py-3 flex-1 flex items-center justify-center shadow-lg border border-gray-800" style={{ minHeight: '160px' }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_green-ride-2/artifacts/3x7h0ptr_Nura%20Safety%20Standard.png" 
                alt="NURA Safety Standard Badge" 
                className="h-32 object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Safety for Riders & Pilots - Side by Side, reduced top spacing */}
      <section className="py-8 bg-black">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            {/* Left - Safety for Riders */}
            <div className="text-left">
              <h2 className="text-3xl font-bold text-white mb-6">Safety for Riders</h2>
              
              <div className="space-y-4">
                {riderHighlights.map((item, index) => (
                  <div
                    key={index}
                    className="bg-gray-900 rounded-xl p-4 border border-gray-800 flex items-center gap-4"
                  >
                    <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-[#bceb39] flex-shrink-0">
                      {item.icon}
                    </div>
                    <p className="text-gray-300">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Right - Safety for Pilots - Left aligned */}
            <div className="text-left">
              <h2 className="text-3xl font-bold text-white mb-6">Safety for Pilots</h2>
              
              <div className="space-y-4">
                {pilotHighlights.map((item, index) => (
                  <div
                    key={index}
                    className="bg-gray-900 rounded-xl p-4 border border-gray-800 flex items-center gap-4"
                  >
                    <div className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-[#bceb39] flex-shrink-0">
                      {item.icon}
                    </div>
                    <p className="text-gray-300">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SafetyPage;
